import { LinearProgress } from 'frontend-components';
import styled from 'styled-components';

const CustomLinearProgress = styled(LinearProgress)`
  && {
    background: #999;

    .MuiLinearProgress-barColorPrimary {
      background-color: #666;
    }
  }
`;

export default CustomLinearProgress;
